import React from "react";
import "./blogs.css";
import BlogList from "../BlogContent/BlogList";
import blogs from "../../data/blogs";

const Blogs = () => {
    return (
        <>
            <div className="blogs-container">
                <h1 className="blogs-title">Our Blog</h1>
                <p className="blogs-subtitle">
                    Insights, strategies, and growth hacks from Born2Scale
                </p>
                <BlogList blogs={blogs} />
            </div>
        </>
    )
}

export default Blogs;